import authModel from '../models/auth';
import {
  SAVE_AUTH,
  LOGOUT
} from '../actions/action';

const auth=authModel();

const initialState=auth.getState();


export default (state=initialState,action)=>{
  const {type}=action;
  if(type === SAVE_AUTH) {
    return {...state,...action.data}
  } else if(type === LOGOUT) {
    auth.doLogout();
    return {...auth.getState()}
  } else {
    return state;
  }
}